<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userKanban).length===0">{{ $t('kanban.no_kanban_available') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex v-for="item in kanbans" :key="item.key" v-bind="layoutItem(item)">
      <kanban-item :item="item" :eventlog="eventlog" @action="onItemAction"></kanban-item>
    </v-flex>
  </v-layout>

  <v-btn color="secondary" dark fixed bottom right fab @click="newKanban" v-if="canCreateKanban">
    <v-icon>add</v-icon>
  </v-btn>

  <kanban-editor v-if="dialogEditor" v-model="dialogEditor" :kanban="dialogEditorKanban" @toast="val=>$emit('toast',val)" @close="onEditorClosed"></kanban-editor>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import KanbanItem from './KanbanItem'
import KanbanEditorDialog from './KanbanEditorDialog'

export default {
  name: 'Kanban',
  mixins: [UserAuth],
  components: {
    'kanban-item': KanbanItem,
    'kanban-editor': KanbanEditorDialog
  },
  data() {
    return {
      eventlog: {},
      dialogEditor: false,
      dialogEditorKanban: null
    }
  },
  computed: {
    loading() {
      return this.kanbanLoading;
    },
    kanbans() {
      return Object.keys(this.userKanban).map(key => ({
        key: key,
        ...this.userKanban[key]
      }));
    },
    canCreateKanban() {
      return !this.loading && Object.keys(this.userKanban).length < 10;
    }
  },
  methods: {
    layoutItem(item) {
      return {
        [`md${item.width || 12}`]: true,
        sm12: true,
        xs12: true
      };
    },
    onItemAction(action, key) {
      switch (action) {
        case 'remove':
          this.removeKanban(key);
          break;
        case 'edit':
          this.editKanban(key);
          break;
        case 'refresh':
          this.refreshKanban(key);
          break;
        case 'inflate':
          this.inflateKanban(key);
          break;
        case 'deflate':
          this.deflateKanban(key);
          break;
      }
    },
    removeKanban(key) {
      let item = this.userKanban[key];
      if (item) {
        this.$db.ref('userKanban').child(this.userId).child(key).remove()
          .catch(err => this.$emit('toast', err.message));
      }
    },
    newKanban() {
      this.dialogEditorKanban = null;
      this.dialogEditor = true;
    },
    editKanban(key) {
      this.dialogEditorKanban = {
        key: key,
        ...this.userKanban[key]
      };
      this.dialogEditor = true;
    },
    onEditorClosed(key) {
      this.dialogEditor = false;
      if (key) this.refreshKanban(key);
    },
    async refreshKanban(key) {
      let item = this.userKanban[key];
      if (item) {
        for (let device of item.devices) {
          let [mac, uid, cid] = device.split('-');
          let cmd = {
            user: this.userId,
            kanban: key,
            mac: mac,
            uid: uid,
            cid: cid,
            eventCode: item.eventCode,
            days: item.days || this.generateJuiceTimeRange(item.chart, item.eventCode),
            juice: this.generateJuiceCommand(item.chart, item.type)
          };
          await this.$db.ref('command/juice').push().set(cmd)
            .catch(err => console.log(err.message, mac));
        }
      }
    },
    inflateKanban(key) {
      let item = this.userKanban[key];
      if (item) {
        let currentWidth = item.width || 12;
        let nextWidth = [4, 6, 8, 12].find(v => v > currentWidth);
        this.$db.ref('userKanban').child(this.userId).child(key).child('width').set(nextWidth)
          .catch(err => this.$emit('toast', err.message));
      }
    },
    deflateKanban(key) {
      let item = this.userKanban[key];
      if (item) {
        let currentWidth = item.width || 12;
        let nextWidth = [12, 8, 6, 4].find(v => v < currentWidth);
        this.$db.ref('userKanban').child(this.userId).child(key).child('width').set(nextWidth)
          .catch(err => this.$emit('toast', err.message));
      }
    },
    generateJuiceCommand(chart, type) {
      switch (chart) {
        case 'trend':
        case 'stepped':
          return 'trend';
        case 'consumption':
          return 'meter';
        case 'histogram':
          return 'histogram';
      }
    },
    generateJuiceTimeRange(chart, eventCode) {
      switch (eventCode) {
        case 4804:
          if (chart === 'trend') return 1;
      }
      return 7;
    },
    shouldRefresh() {
      let now = new Date().getTime();
      Object.keys(this.userKanban).forEach(key => {
        let i = this.userKanban[key];
        if (i.data) {
          let t = Object.values(i.data).reduce((acc, cur) => {
            if (cur.timestamp) acc.push(cur.timestamp[0]);
            return acc;
          }, []).sort(i => i).find(i => i);
          let diff = now - t;
          if (diff < 5 * 60 * 1000) return;
        }
        this.refreshKanban(key);
      });
    }
  },
  mounted() {
    this.$bindAsObject('eventlog', this.$db.ref('userEvent').child(this.userId));
    this.shouldRefresh();
  },
  beforeDestroy() {
    this.$db.ref('userEvent').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/juice/Kanban.vue